import * as React from 'react';
import './SalutationsPage.scss';

import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { routerActions } from 'react-router-redux';
import { Location, History } from "history";
import ReactTable, { RowInfo } from 'react-table';
import * as SalutationActions from '../../../actions/salutations';
import * as Dtos from '../../../dtos/Tmd.dtos';
import { ITmdState, IFormFilter } from "../../../reducers/index";
import { RequestState } from "../../../enumerations/RequestState";
import { Link } from "../../../components/routing/index";
import { FontAwesomeIcon, FontAwesomeIcons } from "../../../constants/fontAwesomeIcons";
import { DEFAULT_PAGE_SIZE, PAGE_SIZE_OPTIONS } from "../../../constants/reactTableConstants";
import * as AuthenticationHelper from '../../../helpers/authentication';
import { FormFilterInput } from '../../../components/form';
import { LookupsLayout } from '../../index';

interface ISalutationsPageProps {

    location: Location;
    history: History;

    // From state
    formFilter: IFormFilter;
    salutation: Dtos.Salutation[];
    loadingSalutations: boolean;
    loadSalutationsSuccess: boolean;
    loadSalutationsFailure: boolean;

    user: Dtos.User;
    permissions?: Dtos.PersonnelTmdPermissions[];
    formRoles?: Dtos.RoleType[];
}

interface ISalutationsPageActions {
    clearSalutations: SalutationActions.ISalutationClearActionCreator;
    loadSalutations: SalutationActions.ISalutationLoadActionCreator;

    navigate: typeof routerActions.push;
    navigateReplace: typeof routerActions.replace;

    filter: SalutationActions.ISalutationFilterActionCreator;
}

type SalutationsPageProps = ISalutationsPageProps & ISalutationsPageActions;

class SalutationsPage extends React.PureComponent<SalutationsPageProps, any> {

    constructor(props: SalutationsPageProps) {
        super(props);

        this.clearSalutations = this.clearSalutations.bind(this);
    }

    componentDidMount() {
        const {
            loadSalutations
        } = this.props;

        loadSalutations();
    }

    componentWillReceiveProps(nextProps: SalutationsPageProps) {
    }

    componentDidUpdate(prevProps: SalutationsPageProps, prevState) {
        const {
            navigateReplace
        } = this.props
    }

    componentWillUpdate(nextProps: SalutationsPageProps) {
    }

    componentWillUnmount() {
        this.clearSalutations();
    }

    clearSalutations() {
        this.props.clearSalutations();
    }

    showSalutations(): boolean {
        const {
            loadingSalutations,
            loadSalutationsSuccess
        } = this.props

        if (!loadingSalutations && loadSalutationsSuccess) {
            return true;
        }

        return false;
    }

    render() {
        const {
            loadingSalutations
        } = this.props;

        return <LookupsLayout loading={loadingSalutations} permission={Dtos.Permission.SalutationsView}>
            {this.renderContent()}
        </LookupsLayout>;
    }

    renderContent() {
        const {
            permissions
        } = this.props;

        return <div>
            <div className="row">
                <div className={"col-6 mb-2"}>
                    <h2>Salutations</h2>
                </div>
                <div className="col-6" style={{ textAlign: 'right' }}>
                    <FormFilterInput formFilter={this.props.formFilter} onFilter={e => this.props.filter(e) } />
                    
                    {AuthenticationHelper.hasPermission(permissions, Dtos.Permission.SalutationsCreate) && (
                        <Link className={"btn btn-primary"} url={"/settings/general/salutations/create"}>Create</Link>
                    )}
                </div>
            </div>
            {
                !this.showSalutations() ?
                    "Loading Salutations" :
                    null
            }
            {
                this.showSalutations() ?
                    <div className="patient-tables mt-2">
                        {
                            this.createTable()
                        }
                    </div> :
                    null
            }
        </div>
    }

    createTable() {

        const {
            salutation
        } = this.props

        if (!salutation || salutation.length == 0) {
            return <div className="alert alert-info d-flex">
                <div className="mr-2">
                    <FontAwesomeIcon icon={FontAwesomeIcons.Solid.INFO_SQUARE} fixedWidth />
                </div>
                <span>There are currently no salutations to view.</span>
            </div>
        }

        const showPagination = salutation.length > DEFAULT_PAGE_SIZE;

        return <div className="table-wrapper mb-3">
            <ReactTable
                data={salutation}
                pageSizeOptions={PAGE_SIZE_OPTIONS}
                defaultPageSize={showPagination ? DEFAULT_PAGE_SIZE : salutation.length}
                pageSize={showPagination ? undefined : salutation.length}
                showPagination={showPagination}
                className="-striped -highlight -clickable mb-3"
                noDataText="There are currently no salutation to display"
                resizable={false}
                getTdProps={(state, rowInfo: RowInfo, column, instance) => {
                    return {
                        onClick: (e, handleOriginal) => {

                            const url: string = "/settings/general/salutations/" + rowInfo.original.id;
                            this.props.navigate(url);

                            if (handleOriginal) {
                                handleOriginal()
                            }

                        },
                        style: {
                            color: (rowInfo && rowInfo.original && rowInfo.original.active) ? '#212529' : '#9e9e9e'
                        }
                    }
                }}
                columns={[
                    {
                        id: "id",
                        Header: ' ',
                        accessor: "id",
                        className: "d-flex align-items-center justify-content-center",
                        maxWidth: 50,
                        Cell: (props) => <FontAwesomeIcon icon={FontAwesomeIcons.Light.LOOKUP} fixedWidth />
                    },
                    {
                        id: "value",
                        Header: 'Name',
                        accessor: 'value',
                        className: "d-flex align-items-left justify-content-left",
                        headerClassName: "text-left"
                    }
                ]}
            />
        </div>

    }

}

const mapStateToProps = (state: ITmdState, ownProps: SalutationsPageProps): ISalutationsPageProps => {

    let permissions = state.user.userSummary ? state.user.userSummary.permissions : [];

    return {

        history: ownProps.history,
        location: state.routing.location,

        formFilter: state.salutations.formFilter,
        salutation: state.salutations.formFilteredData, 

        loadingSalutations: state.salutations.loadState && state.salutations.loadState.status == RequestState.Pending,
        loadSalutationsSuccess: state.salutations.loadState && state.salutations.loadState.status == RequestState.Success,
        loadSalutationsFailure: state.salutations.loadState && state.salutations.loadState.status == RequestState.Failure,

        user: state.user.data,
        permissions: permissions,
        formRoles: state.user.formRoles
    };
};

const mapDispatchToProps = (dispatch): ISalutationsPageActions => {
    return {
        navigate: bindActionCreators(routerActions.push, dispatch),
        navigateReplace: bindActionCreators(routerActions.replace, dispatch),

        loadSalutations: bindActionCreators(SalutationActions.LoadSalutation, dispatch),
        clearSalutations: bindActionCreators(SalutationActions.Clear, dispatch),

        filter: bindActionCreators(SalutationActions.Filter, dispatch),
    };
};

export default
    connect(mapStateToProps, mapDispatchToProps)(SalutationsPage);
